import { Link } from "react-router-dom";
import Seo from "../components/Seo";

export default function NotFound() {
  return (
    <section className="flex min-h-[70vh] items-center bg-navy" data-testid="not-found">
      <Seo title="Page not found" noindex />
      <div className="container-q">
        <p className="font-num text-gold">404</p>
        <h1 className="mt-4 text-4xl font-extrabold text-white sm:text-5xl">This page doesn't exist.</h1>
        <Link to="/" className="mt-8 inline-flex rounded-full bg-mint px-6 py-3 text-sm font-semibold text-navy" data-testid="not-found-home-btn">Back to home</Link>
      </div>
    </section>
  );
}
